module.exports = __webpack_public_path__ + "img/climate_actions_paper.827af95.svg";